'use client';

import dynamic from 'next/dynamic';

const DemoPage = dynamic(() => import('./page'), { ssr: false });

export function DemoClient() {
  return <DemoPage />;
}
